// frontend/src/pages/admin/lcl/components/MaskedIban.jsx
export default function MaskedIban({ iban }) {
  if (!iban) return <span className="text-gray-400">—</span>;
  const clean = iban.replace(/\s+/g, '');
  if (clean.length < 8) return <span className="font-mono">{clean}</span>;
  const head = clean.slice(0, 4);
  const tail = clean.slice(-4);
  return (
    <span className="font-mono text-gray-500">
      {head} **** **** **** {tail}
    </span>
  );
}
